import type { BuilderPublicShowroomCTACustomFieldConfig } from "api-types/builders/salesConfig";
import Checkbox from "ui/forms/Checkbox";
import InputGroup from "ui/forms/InputGroup";
import InputGroupSelect from "ui/forms/InputGroupSelect";
import InputGroupText from "ui/forms/InputGroupText";
import RadioButton from "ui/forms/RadioButton";
import RadioButtonGroup from "ui/forms/RadioButtonGroup";

interface CustomFieldProps {
  field: BuilderPublicShowroomCTACustomFieldConfig;
  index: number;
  value: string;
  disabled?: boolean;
  onChange: (value: string) => void;
}

export function CustomField({ field, index, value, onChange, disabled }: CustomFieldProps) {
  let formField: React.ReactNode;

  const label = field.customPrompt || field.name;

  switch (field.type) {
    case "TEXT":
      formField = (
        <InputGroupText
          type="text"
          labelText={label}
          inputValue={value}
          onChange={onChange}
          autoComplete="off"
          required={field.required}
          disabled={disabled}
          placeholder={field.name}
        />
      );
      break;
    case "SELECT":
      formField = (
        <InputGroupSelect
          labelText={label}
          value={value}
          onChange={(value) => onChange(String(value))}
          options={field.options?.map((option) => ({ label: option.label, value: option.value })) || []}
          required={field.required}
          disabled={disabled}
          placeholder={`Select ${field.name}`}
        ></InputGroupSelect>
      );
      break;
    case "CHECKBOX":
      formField = (
        <Checkbox
          label={label}
          value="true"
          checked={value === "true"}
          onChangeBoolean={(val) => onChange(val ? "true" : "false")}
          disabled={disabled}
        />
      );
      break;
    case "RADIO":
      formField = (
        <InputGroup labelText={label}>
          <RadioButtonGroup orientation="vertical">
            {(field.options || []).map((option, idx) => (
              <RadioButton
                key={idx}
                label={option.label}
                name={`custom-field-radio-${index}`}
                value={option.value}
                checked={value === option.value}
                onChange={() => onChange(option.value)}
                disabled={disabled}
              />
            )) || null}
          </RadioButtonGroup>
        </InputGroup>
      );
      break;
    default:
      formField = null;
  }

  if (!formField) {
    return null;
  }

  return <div className="field">{formField}</div>;
}
